import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(e) { console.error("RallyLove UI error", e); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-screen grain-bg flex items-center justify-center px-5" data-testid="error-page">
        <div className="max-w-md text-center">
          <img src="/logo-mark.png" alt="Rally Love" className="w-20 mx-auto mb-6 opacity-70" />
          <div className="pill-badge inline-flex mb-4">QUALCOSA NON HA FUNZIONATO</div>
          <h1 className="headline-huge text-4xl mb-4">Bandiera rossa.</h1>
          <p className="text-slate-400 mb-8">Non è stato possibile completare l'operazione. Riprova tra qualche istante oppure contatta l'assistenza Rally Love.</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <a href="/" className="btn-crimson" data-testid="error-home">TORNA ALLA HOME</a>
            <a href="/p/assistenza" className="btn-outline-rl" data-testid="error-support">ASSISTENZA</a>
          </div>
        </div>
      </div>
    );
  }
}
